import React from 'react';
import { useTranslation } from 'react-i18next';
import { InlineNotification } from '@carbon/react';
import { useBilling } from 'src/hooks/useBilling';

export function quotaLevel(used: number, limit: number | null): 'ok' | 'near' | 'over' {
  if (limit === null) return 'ok';
  if (used >= limit) return 'over';
  return used >= limit * 0.8 ? 'near' : 'ok';
}

/** Warns only. The POS never stops selling because of the Free order quota. */
export default function OrderQuotaBanner() {
  const { t } = useTranslation();
  const { data } = useBilling();
  if (!data?.enabled) return null;
  const used = data.usage.ordersThisMonth;
  const limit = data.limits.ordersPerMonth ?? null;
  const level = quotaLevel(used, limit);
  if (level === 'ok') return null;
  return (
    <InlineNotification
      kind={level === 'over' ? 'error' : 'warning'}
      lowContrast
      hideCloseButton
      title=""
      subtitle={level === 'over' ? t('billing.quota.over') : t('billing.quota.near', { used, limit })}
    />
  );
}
